import api from "../Api";

// helper: build auth headers from stored token
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};
// جلب شركات الشحن
export const getShippingCompanies = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(
      `/admin/get-shipping-company`,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching shipping companies:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// إنشاء شركة شحن جديدة
export const createShippingCompany = async (data, params = {}) => {
  /**
   * data = {
   *   name: string,
   *   address: string,
   *   phone: string,
   *   email: string
   * }
   */

  if (!data || typeof data !== "object") {
    throw new Error("data is required to create shipping company.");
  }

  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  const headers = {
    "Content-Type": "multipart/form-data",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/create-shipping-company`,
      formData,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating shipping company:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// تحديث شركة شحن
export const updateShippingCompany = async (companyOrId, data, params = {}) => {
  const companyId =
    typeof companyOrId === "object" && companyOrId !== null
      ? companyOrId.id
      : companyOrId;

  if (!companyId) {
    throw new Error("companyId is required to update shipping company.");
  }

  if (!data || typeof data !== "object") {
    throw new Error("data is required to update shipping company.");
  }

  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  const headers = {
    "Content-Type": "multipart/form-data",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/update-shipping-company/${companyId}`,
      formData,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating shipping company:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// حذف شركة الشحن بواسطة id
// حذف شركة الشحن بواسطة id (مطابق للـ API)
export const deleteShippingCompany = async (companyId, params = {}) => {
  if (!companyId) throw new Error("companyId is required to delete shipping company.");

  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(
      `/admin/delete-shipping-company/${companyId}`,
      {
        headers,
        params: mergedParams,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting shipping company:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
